<button mat-button [disabled]="disabled" (click)="executeAction()" [matTooltip]="tooltip">
    <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
    <mat-icon *ngIf="materialIcon">{{materialIcon}}</mat-icon>
</button>
